/**
 * Category label from a catalog service (if the API provides one).
 */
export function getServiceCategoryLabel(service) {
  if (!service || typeof service !== 'object') return '';
  const cn = service.categoryName;
  if (cn != null && String(cn).trim()) return String(cn).trim();
  if (service.category && typeof service.category === 'object' && service.category.name) {
    return String(service.category.name).trim();
  }
  if (typeof service.category === 'string' && service.category.trim()) {
    return service.category.trim();
  }
  return '';
}

/**
 * Single description field for the backend:
 *   Category : <name>
 *   <description on the next row>
 * No separate categoryName field — category lives only in this text.
 */
export function buildDescriptionWithCategoryFirst(categoryLabel, bodyText) {
  const c = String(categoryLabel ?? '').trim();
  const b = String(bodyText ?? '').trim();
  if (c && b) return `Category : ${c}\n${b}`;
  if (c) return `Category : ${c}`;
  return b;
}

/** True when description uses the cart/API "Category : …" first line (case-insensitive). */
export function descriptionHasCategoryPrefix(description) {
  if (typeof description !== 'string' || !description.trim()) return false;
  return /^category\s*:\s/m.test(description.trimStart());
}

/** Text after the first `Category : …` line (for API payloads that send category separately). */
export function descriptionBodyWithoutCategoryLine(description) {
  if (typeof description !== 'string') return '';
  const d = description.trim();
  if (!/^category\s*:/im.test(d)) return d;
  const nx = d.indexOf('\n');
  if (nx === -1) return '';
  return d.slice(nx + 1).trim();
}
